import React, { Component, PropTypes } from 'react';
import ChartistGraph from 'react-chartist';
import Chartist from 'chartist';
import moment from 'moment';
import pointInPolygon from 'point-in-polygon';
import ImageBrightness from 'material-ui/svg-icons/image/brightness-1';
import { orange500, red600 } from 'material-ui/styles/colors';
import { groupBy, maxBy, values } from 'lodash';
import radium from 'radium';

import base from '../../styles';
import css from './Chart.css'; // eslint-disable-line no-unused-vars

const styles = {
  chart: {
    height: 250,
    '@media (min-width: 800px)': {
      height: 300,
    },
    '@media (min-width: 1200px)': {
      height: 350,
    },
    '@media (min-width: 1400px)': {
      height: 400,
    },
  },
  chartist: {
    height: '100%',
  },
  legend: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    marginBottom: 12,
    marginRight: 14,
    marginTop: 4,
    float: 'right',
  },
  legendItem: {
    marginBottom: 6,
  },
  legendLabel: {
    marginLeft: 8,
    fontSize: 12,
    color: base.textColor,
  },
  legendIcon: {
    width: 16,
    height: 16,
    marginBottom: -3,
  },
};

const calculateGraphData = (rawData, region) => {
  const filteredEntries = region ?
    rawData.filter((entry) => pointInPolygon([entry.lng, entry.lat], region.polygon)) :
    rawData;

  const labels = [];
  const fault = [];
  const maintenance = [];

  const now = new Date();

  for (let h = 23; h >= 0; h--) {
    for (let m = 59; m >= 0; m--) {
      labels.push(now - (((h * 3600) + (m * 60)) * 1000));
    }
  }

  labels.forEach((instant) => {
    const entries = filteredEntries.filter((entry) => instant >= entry.startedAt &&
      (entry.endedAt === null || instant <= entry.endedAt));
    const faultEntries = entries.filter((entry) => entry.outageType === 'fault');
    const maintenanceEntries = entries.filter((entry) => entry.outageType === 'maintenance');

    const faultsByStation = values(groupBy(faultEntries, 'stationCode'));
    const maintenancesByStation = values(groupBy(maintenanceEntries, 'stationCode'));

    const faultCustomers = faultsByStation
      .map((stationEntries) => maxBy(stationEntries, 'customers').customers)
      .reduce((sum, customers) => sum + customers, 0);
    const maintenanceCustomers = maintenancesByStation
      .map((stationEntries) => maxBy(stationEntries, 'customers').customers)
      .reduce((sum, customers) => sum + customers, 0);

    fault.push(faultCustomers);
    maintenance.push(maintenanceCustomers);
  });

  return {
    labels: labels.map((label) => moment(label).format('HH:mm')),
    series: [
      maintenance,
      fault,
    ],
  };
};

// Choose how many labels to show based on available space
const getModulo = () => Math.max(Math.round(6 - (window.innerWidth / 320)), 1);

const options = {
  axisX: {
    labelInterpolationFnc: (value) => ((value.substr(3) === '00' &&
      parseInt(value.substr(0, 2), 10) % getModulo() === 0) ? value : null),
  },
  axisY: {
    onlyInteger: true,
  },
  lineSmooth: Chartist.Interpolation.none({
    fillHoles: true,
  }),
  showPoint: false,
};

class Chart extends Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    selectedRegion: PropTypes.object,
  };

  render() {
    const { data, selectedRegion } = this.props;
    let heading = 'Sähköttömien asiakkaiden lukumäärän kehitys';
    if (selectedRegion) {
      heading += `: ${selectedRegion.name}`;
    }
    return (
      <div>
        <h2 style={base.h2}>{heading}</h2>
        <div style={styles.chart}>
          <ChartistGraph
            data={calculateGraphData(data, selectedRegion)}
            options={options}
            style={styles.chartist}
            type="Line"
          />
        </div>
        <div>
          <ul style={styles.legend}>
            <li style={styles.legendItem}>
              <ImageBrightness style={{ ...styles.legendIcon, fill: red600 }} />
              <span style={styles.legendLabel}>Vikakeskeytys</span>
            </li>
            <li style={styles.legendItem}>
              <ImageBrightness style={{ ...styles.legendIcon, fill: orange500 }} />
              <span style={styles.legendLabel}>Työkeskeytys</span>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default radium(Chart);



// WEBPACK FOOTER //
// ./src/components/Chart/Chart.js